import moment from "moment";
import Profile from "@/scripts/_profile.js";
import Channel from "@/scripts/_channel.js";
import defaultMixin from "./default";
import {
	extend
} from "vee-validate";
import {
	email,
	required,
	between
} from "vee-validate/dist/rules";
import {
	EventBus
} from "../scripts/_eventBus.js";
import {
	mapActions,
	mapState
} from 'vuex';

export default {
	mixins: [defaultMixin],
	methods: {
		...mapActions(["setChannel"]),
		...mapActions(["setProfile"]),
		loadChannel() {
			var command = '/settings';
			this.apiRequest(command, null, "GET", response => {
				if (response.Value) {
					document.title = response.Value.Address.Venue.Name;
					if (response.Value.Terms && response.Value.Terms.Items) {
						response.Value.Terms.Items.forEach(element => {
							element.isAccepted = false;
						});
					}

					if (!response.Value.Fields.TravelerEmail)
						response.Value.Fields.TravelerEmail = {
							IsVisible: false,
							IsRequired: false
						};

					if (!response.Value.Fields.TravelerAddress)
						response.Value.Fields.TravelerAddress = {
							IsVisible: false,
							IsRequired: false
						};

					if (!response.Value.Fields.TravelerPostalCode)
						response.Value.Fields.TravelerPostalCode = {
							IsVisible: false,
							IsRequired: false
						};

					if (!response.Value.Fields.TravelerCity)
						response.Value.Fields.TravelerCity = {
							IsVisible: false,
							IsRequired: false
						};


					//
					Channel._oid = response.Value._oid;
					Channel._uuid = response.Value._uuid;
					Channel._Versioned = response.Value._Versioned;
					Channel.Admin = response.Value.Admin;
					Channel.bearerToken = response.Value.BearerToken;
					Channel.Address = response.Value.Address;
					Channel.Directory = response.Value.Directory;
					Channel.AllPeriods = response.Value.Periods;
					Channel.Payment = response.Value.Payment;
					Channel.Terms = response.Value.Terms;
					Channel.Restrictions = response.Value.Restrictions;
					Channel.Alternatives = response.Value.Alternatives;
					Channel.Mode = response.Value.Mode;
					Channel.Dates = response.Value.Dates;
					Channel.Theme = response.Value.Theme;
					Channel.Content = response.Value.Content;
					Channel.Type = response.Value.Type;
					Channel.Imprint = response.Value.Imprint;
					Channel.Fields = response.Value.Fields;
					Channel.Questions = response.Value.Questions;
					Channel.Settings = response.Value.Settings;
					Channel.Shifts = response.Value.Shifts;
					Channel.UserProfile = response.Value.UserProfile;
					Channel.isLoaded = false;
					Channel.DepartmentOrProduct = this.$route.params.departmentOrProduct;

					//
					this.setChannel(Channel);
					if (this.reservation !== null) this.reservation.Mode = Channel.Mode;
					if (this.reservation !== null && this.reservation.Mode === "ShiftsOrDates" && Channel.Dates.some(c => c.Type === "Ticket")) this.reservation.Mode = "Shifts";

					//
					if (response.Value.Protection && response.Value.Protection.IsActive) {
						window.setTimeout(() => this.$modals.show("password"), 100);
					} else {
						EventBus.$emit("channel_loaded");
					}
				}
			});
		},
		onPassword() {
			var command = `/settings/password/${encodeURIComponent(this.reservation.Protection.Password)}`;
			this.apiRequest(command, null, "GET", response => {
				this.passwordIsInvalid = !response.Value;
				if (response.Value) {
					this.$modals.hide("password");
					Channel.isLoaded = true;
				}
			});
		},
	},
	mounted() {
		//
		extend("required", {
			...required,
			key: "{_field_}",
			message: (key) => {
				return `${this.T("OneTicketing_Please_Enter_start")} ${this.T(key)} ${this.T("OneTicketing_Please_Enter_end")}`
			}
		});
		extend("email", {
			...email,
			message: () => {
				return `${this.T("OneTicketing_Please_Enter_Valid_Email")}`
			}
		});
		extend('requiredCb', {
			validate: value => {
				return value;
			},
			key: "{_field_}",
			message: (key) => {
				return `${this.T("OneTicketing_Please_Accept")} ${this.T(key)}.`
			}
		});
		extend("between", {
			...between,
			min: "{min}",
			max: "{max}",
			message: (min, max) => {
				return `${this.T("OneTicketing_Age_between_start")} ${min} ${this.T("and")} ${max} ${this.T("OneTicketing_Age_between_end")}`
			}
		});
		extend("dateFormat", {
			params: ["format"],
			validate(value, {
				format
			}) {
				return value === null || (moment(value, format).isValid() && moment(value, format).year() >= 1900 && moment(value, format).year() <= moment().year());
			},
			message: () => {
				return `${this.T("OneTicketing_Please_check_birthdate")}`
			}
		});
		extend("emailConfirm", {
			params: ["target"],
			validate(value, {
				target
			}) {
				return value === null || value === target;
			},
			message: () => {
				return `${this.T("OneTicketing_Email_Confirmation_does_not_match")}`
			}
		});

		//
		let groups = document.querySelectorAll(".form-group input");
		for (let i = 0; i < groups.length; i++) {
			let group = groups[i];

			group.addEventListener("focus", function (e) {
				e.target.parentNode.classList.add("active");
			});

			group.addEventListener("blur", function (e) {
				e.target.parentNode.classList.remove("active");
			});
		}

		//
		this.loadChannel();
		if (!this.profile) this.setProfile(Profile);
	},
	computed: {
		...mapState(["reservation", "registration", "channel", "profile"]),
	}
}